import { CalendarClock } from "lucide-react"
import { parseServerDate } from "@/lib/utils"

/**
 * „Daten erst ab …" — der gewählte Zeitraum reicht weiter zurück als die Daten (#101).
 *
 * Frage aus #101: „Eine Auswertung, die stillschweigend nur X Tage kennt,
 * sieht aus wie ein Ergebnis, ist aber eine Messlücke." Die Wege-Aufzeichnung
 * begann am 27.08.2026 — „90 Tage" waren bis dahin gut drei Wochen.
 *
 * Das Backend liefert `daten_ab` (ältester zugrunde liegender Eintrag, gefiltert
 * wie die Auswertung). Ist der Zeitraum vollständig abgedeckt oder fehlt das
 * Datum (Ermittlung fehlgeschlagen), steht hier nichts.
 */

const TAG_MS = 24 * 60 * 60 * 1000

export function datenstand(
  datenAb: string | null | undefined,
  tage: number,
  jetzt: Date = new Date(),
): { ab: Date; gefuellt: number } | null {
  const ab = parseServerDate(datenAb)
  if (!ab || !(tage > 0)) return null
  if (ab.getTime() <= jetzt.getTime() - tage * TAG_MS) return null
  const gefuellt = Math.max(1, Math.floor((jetzt.getTime() - ab.getTime()) / TAG_MS))
  if (gefuellt >= tage) return null
  return { ab, gefuellt }
}

export function DatenstandHinweis({ datenAb, tage }: { datenAb: string | null | undefined; tage: number }) {
  const d = datenstand(datenAb, tage)
  if (!d) return null
  return (
    <div
      className="flex items-start gap-2 mb-4 text-[12.5px] text-muted-foreground"
      data-testid="datenstand-hinweis"
    >
      <CalendarClock className="w-4 h-4 mt-0.5 shrink-0" />
      <span>
        Daten erst ab {d.ab.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" })} —
        die {tage} Tage sind nur zu {d.gefuellt} {d.gefuellt === 1 ? "Tag" : "Tagen"} gefüllt.
      </span>
    </div>
  )
}
